exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".relatedOps--header--3qcrIRMs {\r\n  color: #0072CE;\r\n  margin-bottom: 6px;\r\n  font-weight: 400;\r\n  padding-left: 16px;\r\n}\r\n\r\n.relatedOps--relatedOpRow--ZwiDmnFx {\r\n  margin-bottom: 36px;\r\n  padding-left:16px;\r\n  padding-right: 16px;\r\n}\r\n", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/components/opportunity/relatedOps/relatedOps.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;CACpB;;AAED;EACE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;CACrB","file":"relatedOps.css","sourcesContent":[".header {\r\n  color: #0072CE;\r\n  margin-bottom: 6px;\r\n  font-weight: 400;\r\n  padding-left: 16px;\r\n}\r\n\r\n.relatedOpRow {\r\n  margin-bottom: 36px;\r\n  padding-left:16px;\r\n  padding-right: 16px;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"header": "relatedOps--header--3qcrIRMs",
	"relatedOpRow": "relatedOps--relatedOpRow--ZwiDmnFx"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/opportunity/relatedOps/relatedOps.css
// module id = 395
// module chunks = 0